export const getLivePersonComponent = (document: Document): Element | null =>
  (document && document.querySelector('.LPMcontainer')) || null

export const isLiveChatAvailable = (document: Document) =>
  getLivePersonComponent(document) ? true : false

export const getLiveChatContainer = (document: Document) =>
  getLivePersonComponent(document)?.childNodes[0] as HTMLElement | null
